'use client'

import { useState } from 'react'
import { Button, Card, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/business-accounts/business-accounts-data'

import AddCountryUinModal from '../AddCountryUinModal'

type Props = {
  countryTitle: string
  disableAdd: boolean
  refetch: () => void
}

const AddUinBlock = ({ countryTitle, disableAdd, refetch }: Props) => {
  const translate = useTranslate('epr_settings.add_uin')
  const { track } = useTracking()

  const [isAddUinModalOpen, setIsAddUinModalOpen] = useState(false)

  const handleAddUinClick = () => {
    setIsAddUinModalOpen(true)

    track(
      clickEvent({
        target: 'add_epr_uin',
        screen: 'epr_settings',
      }),
    )
  }

  const handleCloseModal = () => {
    setIsAddUinModalOpen(false)
  }

  const renderAddUinButton = () => (
    <Button
      text={translate('button')}
      styling={Button.Styling.Filled}
      onClick={handleAddUinClick}
      disabled={disableAdd}
    />
  )

  return (
    <>
      <Card>
        <div className="u-flexbox add-uin-block u-ui-padding-large">
          <div>
            <div>
              <Text as="h2" text={`${translate('title')} ${countryTitle}`} type={Text.Type.Title} />
            </div>
            <div className="u-ui-padding-right-x-large">
              <Text
                as="span"
                text={translate('description', { countryTitle })}
                type={Text.Type.Body}
              />
            </div>
          </div>
          <div className="u-flexbox u-align-items-center">
            <div className="add-uin-block__button">{renderAddUinButton()}</div>
          </div>
        </div>
      </Card>
      <AddCountryUinModal show={isAddUinModalOpen} onClose={handleCloseModal} refetch={refetch} />
    </>
  )
}

export default AddUinBlock
